import React, { FC } from 'react'
import FhirLoader from '../../components/FhirLoader'
import ReactMarkdown from 'react-markdown'
import PageTitle from '../../components/PageTitle'
import useReleaseNotes from '../../hooks/releasenotes'

import './index.scss'
import isAuthenticated from '../../routes/PrivateRoute'
import PermissionGate from '../../components/PermissionGate'
import useUserWithRole from '../../hooks/authentication/useUserWithRole'

const ReleaseNotes: FC = () => {
  const { user, isLoading: userLoading } = useUserWithRole()
  const { data: releaseNotes, isLoading, error } = useReleaseNotes()
  if (userLoading || isLoading) return <FhirLoader message='Loading...' />
  if (error) return <p>Error loading notes</p>

  return (
    <PermissionGate user={user} role="admin">
      <section className="content">
        <PageTitle displayName="Release Notes" />
        <h1 className="release-notes__title">
          Connect ID Member Portal Release Notes
        </h1>

        {releaseNotes?.map(note => (
          <div key={note.version} className="release-notes__markdown">
            <ReactMarkdown>{note.content}</ReactMarkdown>
          </div>
        ))}
      </section>
    </PermissionGate>
  )
}

export default isAuthenticated(ReleaseNotes)